<template>
  <div class="sourceMarket">
    <div class="warpper">
      <div class="tabs">

        <div v-for="(item,index) in tags"
             class="tab"
             :class="{'active':item.id==active}"
             @click="selTag(item.id)">
          <span>{{ item.title }}</span>
        </div>
      </div>
      <div class="panels">
        <div class="panel">
          <alibaba-product-list v-show="active==1033"></alibaba-product-list>
          <add-vue v-show="active==1034"></add-vue>
        </div>
      </div>
    </div>
    <helpOther :helpUrl="'https://www.yuque.com/bocai007/zgqd2m/ast908nv4zfpnvwu'"></helpOther>
  </div>
</template>
<script>
import helpOther from "../../components/helpOther.vue";
import addVue from "./add.vue";
import AlibabaProductList from "../alibaba/product/alibabaProductList.vue";

export default {
  components: {AlibabaProductList, addVue,helpOther},
  data() {
    return {
      active: 1033,
      tags: [
        {id: 1033, title: "阿里巴巴"},
        {id: 1034, title: "卟云供应"},

      ]
    }
  },
  created() {
   //  let b = true
   //  let newTags = this.tags.filter((item, index) => {
   //    if (JSON.parse(localStorage.getItem('ruleIds')).indexOf(item.id) > -1) {
   //      if (b) {
   //        b = false
   //        this.active = item.id
   //      }
   //      return true;
   //    } else {
   //      return false;
   //    }
   //  })
   // this.tags = newTags;
   const savedActive = localStorage.getItem('activeTab');
    if (savedActive) {
      this.active = parseInt(savedActive);
    }
  },
  methods: {
    selTag(id) {
      console.log(this.active, id);
      this.active = id;
      localStorage.setItem('activeTab', id);
    }
  }
}
</script>
<style scoped>

.sourceMarket {
  position: relative;
  --color: #409EFF;
  width: 100%;
  height: 100%;
}

.warpper {
  position: absolute;
  top: -10px;
  left: -10px;
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
}

.tab {
  cursor: pointer;
  padding: 5px 30px;
  margin: 0px 0px;
  background: var(--color);
  display: inline-block;
  color: #fff;
  position: relative;
  box-sizing: border-box;
}
.tab span{
  padding-left: 10px;
}
.tab:first-child {
  border-top-left-radius: 4px;
}

.panels {
  background: #fff;
  min-height: 200px;
  box-sizing: border-box;
  height: calc(100% - 20px);
  overflow: hidden;
  padding: 20px;
}

.panel {
  animation: fadein 0.8s;
  height: 100%;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.active {
  background: #fff;
  color: rgba(0, 0, 0, 0.5);
  font-weight: bold;
  border-top: 2px solid var(--color);
  border-top-left-radius: 4px;
}
.tab::after {
  content: " ";
  width: 34px;
  height: 34px;
  position: absolute;
  right: -33px;
  top: 0;
  background-color: var(--color);
  clip-path: polygon(0 0, 0 100%, 100% 100%);
  z-index: 2;
}

.active.tab::after {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/supplier/sourceMarket.vue